import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Jane D.",
  quote: "Gold Star Executive Cleaning always exceeds our expectations with their thorough and reliable service.",
  position: "Facilities Manager",
  rating: 5
}, {
  author: "Michael R.",
  quote: "Their attention to detail and professionalism make them our preferred cleaning provider.",
  position: "Building Supervisor",
  rating: 5
}, {
  author: "Sarah L.",
  quote: "We've never had a cleaning team so dedicated to maintaining high hygiene standards in our childcare centre.",
  position: "Centre Director",
  rating: 5
}, {
  author: "David K.",
  quote: "Reliable, efficient, and trustworthy. The team does a fantastic job with our strata complex every week.",
  position: "Strata Manager",
  rating: 5
}, {
  author: "Emily W.",
  quote: "The gold standard in commercial cleaning. Our offices have never looked better.",
  position: "Office Manager",
  rating: 5
}];
export default function CustomerTestimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}